import { NavMenuContext } from './context/NavMenuContext'
import { ThemeBuilder } from './context/ThemeBuilderContext'
import { AuthenticationContext } from './context/AuthenticationContext'
import { VersionCheckerContext } from './context/VersionCheckerContext'
import { ToastMessagePopup } from './context/ToastPopUpContext'
import { SocketContextProvider } from './context/SocketContext'
import { MinimizerContext } from './context/MinimizeContext'
import { QuickStartWizardContext } from './context/QuickStartWizard'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { GlobalStateContext } from './context/GlobalStateContext'

/// Inititalize React Query Class
const queryClient = new QueryClient()

const App = () => {
    return (
        <ThemeBuilder>
            <ToastMessagePopup>
                <AuthenticationContext>
                    <SocketContextProvider>
                        <GlobalStateContext>
                            <QueryClientProvider client={queryClient}>
                                <VersionCheckerContext>
                                    <MinimizerContext>
                                        <QuickStartWizardContext>
                                            <NavMenuContext />
                                        </QuickStartWizardContext>
                                    </MinimizerContext>
                                </VersionCheckerContext>
                            </QueryClientProvider>
                        </GlobalStateContext>
                    </SocketContextProvider>
                </AuthenticationContext>
            </ToastMessagePopup>
        </ThemeBuilder>
    )
}

export default App
